import { css, cx } from '@emotion/css'
import { theme } from '../styles/theme.js'
import { Card } from '../components/Card.jsx'
import { Button } from '../components/Button.jsx'
import { User } from 'lucide-react'

const styles = {
  container: css({
    paddingTop: theme.spacing.sm,
  }),
  header: css({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.lg,
    marginBottom: theme.spacing.xl,
  }),
  avatar: css({
    width: '72px',
    height: '72px',
    borderRadius: theme.radii.full,
    backgroundColor: theme.colors.surfaceElevated,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `2px solid ${theme.colors.primary}`,
  }),
  name: css({
    fontSize: theme.typography.fontSize.xxl,
    fontWeight: 700,
  }),
  handle: css({
    color: theme.colors.textMuted,
  }),
  section: css({
    marginBottom: theme.spacing.xl,
  }),
  sectionTitle: css({
    fontSize: theme.typography.fontSize.lg,
    fontWeight: 600,
    marginBottom: theme.spacing.md,
    color: theme.colors.textMuted,
    textTransform: 'uppercase',
    letterSpacing: '1px',
    fontSize: '12px',
  }),
  row: css({
    display: 'flex',
    justifyContent: 'space-between',
    padding: `${theme.spacing.md} 0`,
    borderBottom: `1px solid ${theme.colors.border}`,
    fontSize: theme.typography.fontSize.base,
  }),
}

const Profile = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.avatar}>
          <User size={36} color={theme.colors.primary} />
        </div>
        <div>
          <div className={styles.name}>Alex Rivera</div>
          <div className={styles.handle}>@arivera • Level 12</div>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionTitle}>Progress</div>
        <Card>
          <div className={styles.row}>
            <span>Chapters completed</span>
            <strong>14 / 24</strong>
          </div>
          <div className={styles.row}>
            <span>Current streak</span>
            <strong>9 days</strong>
          </div>
          <div className={styles.row} style={{ borderBottom: 'none' }}>
            <span>Total time</span>
            <strong>41h 12m</strong>
          </div>
        </Card>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionTitle}>Account</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: theme.spacing.sm }}>
          <Button variant="secondary" fullWidth>Edit profile</Button>
          <Button variant="ghost" fullWidth>Settings</Button>
          <Button variant="ghost" fullWidth>Sign out</Button>
        </div>
      </div>
    </div>
  )
}

export { Profile }
